import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import theme from './theme';

/**
 * Emotion style classes
 */
const strongText = css`
  b,
  strong {
    color: ${theme.color.highlight};
  }

  h2,
  h3,
  h4 {
    color: ${theme.color.primary} !important;
  }

  abbr {
    border-bottom: 1px dotted ${theme.color.highlight};
    cursor: help;
  }
`;

/**
 * Components
 */
const MarkdownText = ({ children }) => (
  <div
    className={`content ${strongText}`}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);

MarkdownText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]).isRequired,
};

export default MarkdownText;
